import type { BillingPlanId } from "../types/billing";

const PENDING_CHECKOUT_PLAN_KEY = "pending_checkout_plan";

const isBillingPlanId = (value: string | null): value is BillingPlanId =>
  value === "pro_monthly" || value === "agency_monthly";

const canUseSessionStorage = () => typeof window !== "undefined";

export const getCheckoutPlanFromSearch = (
  search: string
): BillingPlanId | null => {
  const params = new URLSearchParams(search);
  const plan = params.get("plan");
  return isBillingPlanId(plan) ? plan : null;
};

export const setPendingCheckoutPlan = (planId: BillingPlanId) => {
  if (!canUseSessionStorage()) {
    return;
  }

  window.sessionStorage.setItem(PENDING_CHECKOUT_PLAN_KEY, planId);
};

export const getPendingCheckoutPlan = (): BillingPlanId | null => {
  if (!canUseSessionStorage()) {
    return null;
  }

  const plan = window.sessionStorage.getItem(PENDING_CHECKOUT_PLAN_KEY);
  return isBillingPlanId(plan) ? plan : null;
};

export const clearPendingCheckoutPlan = () => {
  if (!canUseSessionStorage()) {
    return;
  }

  window.sessionStorage.removeItem(PENDING_CHECKOUT_PLAN_KEY);
};

export const clearPlanQueryFromUrl = () => {
  if (typeof window === "undefined") {
    return;
  }

  const url = new URL(window.location.href);
  url.searchParams.delete("plan");
  const nextUrl = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState(null, "", nextUrl);
};
